(function () {
  if (window.__mbtProduct) return; window.__mbtProduct = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var io = ('IntersectionObserver' in window && !reduce && !design) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mbt-active'); io.unobserve(e.target); } });
  }, { threshold: 0.1 }) : null;
  function scan(root) { (root || document).querySelectorAll('.mbt-reveal:not(.mbt-active)').forEach(function (el) { if (io) io.observe(el); else el.classList.add('mbt-active'); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
